/* unplugin-vue-components disabled */import { render } from "./DocumentationView.vue?vue&type=template&id=4c5404fd"
import script from "./DocumentationView.vue?vue&type=script&lang=js"
export * from "./DocumentationView.vue?vue&type=script&lang=js"

import "./DocumentationView.vue?vue&type=style&index=0&id=4c5404fd&lang=scss"

import exportComponent from "D:\\Project\\Juanfu\\CBK定制版\\hcontrol_download\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__